import HeroSlider from './Slider/Slider';
import HeroSlide from './Slider/Slide';
import Box, { BoxRow } from './Box';
import ColorBox, { ColorBoxRow } from './ColorBox';
import BestSellers from './BestSellers';
import { Link } from 'react-router-dom';
import { styled } from 'linaria/react';
import React, { useContext } from 'react';
import { SideBySide } from './SideBySide/SideBySide';
import { theme } from '../../Theme';
import ProductBox, { ProductRow } from './ProductBox';
import { css } from 'linaria';
import { Usps, UspItem } from '../../Cart/Usps';
import { StyledTitle } from './Title';
import { CategoryLinkRow } from './CategoryLinkRow/CategoryLinkRow';
import { CategoryLinkRowItem } from './CategoryLinkRow/CategoryLinkRowItem';
import { Spacer } from './Spacer';
import { ProductPageUSP } from '../../ProductPage/ProductPageUSP';
import { ProductPageUSPItem } from '../../ProductPage/ProductPageUSP';
import CampaignBar from '../../Layout/CampaignPush/CampaignBar';
import Text from '../../Layout/TextContent/Text';
import StyledProductRow from '../ContentRendererComponents/StyledProductRow';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import { HtmlBannerRow } from './HtmlBanner/HtmlBannerRow';
import { HtmlBannerRowItem } from './HtmlBanner/HtmlBannerRowItem';
import { ImageGrid } from './ImageGrid';
import { HtmlBlock } from './HtmlBlock';
import { ElevateRecommendedProducts } from './ElevateRecommendedProducts';

export const standardText = css`
  p {
    font-family: ${theme.fonts.primary};
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 10px;
    letter-spacing: 0.02em;
  }

  ul,
  ol {
    font-family: ${theme.fonts.primary};
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 10px;
    letter-spacing: 0.02em;
  }
  ul,
  ol {
    list-style: revert !important;
  }
`;

const LimitedWidth = styled('div')`
  max-width: 94rem;
  width: 100%;
  margin: auto;
  padding: 3rem 2rem;
  &.gmf-start-page-slideshow {
    ${theme.below.xl} {
      padding: 2rem 0rem;
    }
  }
`;

const CommunityActivity = () => {
  const { selectedChannel } = useContext(ChannelContext);
  const isEu = selectedChannel.id === 2;

  if (isEu) return null;
  return <LimitedWidth className="gmf-start-page-slideshow" />;
};

export const allComponents = {
  HEROSLIDER: HeroSlider,
  HEROSLIDE: HeroSlide,
  BOXROW: BoxRow,
  BOX: Box,
  COLORBOX: ColorBox,
  COLORBOXROW: ColorBoxRow,
  BESTSELLERS: BestSellers,
  SIDEBYSIDE: SideBySide,
  PRODUCTBOX: ProductBox,
  PRODUCTROW: ProductRow,
  'COMMUNITY ACTIVITY': CommunityActivity,
  TITLE: StyledTitle,
  CATEGORYLINKROW: CategoryLinkRow,
  CATEGORYLINKROWITEM: CategoryLinkRowItem,
  SPACER: Spacer,
  CAMPAIGNBAR: CampaignBar,
  TEXT: Text,
  STYLEDPRODUCTROW: StyledProductRow,
  HTMLBANNERROW: HtmlBannerRow,
  HTMLBANNERROWITEM: HtmlBannerRowItem,
  'IMAGE GRID': ImageGrid,
  HTMLBLOCK: HtmlBlock,
  ELEVATEPRODUCTRECOMMENDATION: ElevateRecommendedProducts
};

export const cartComponents = {
  USPS: Usps,
  HTMLCONTENT: UspItem
};

export const productPageComponents = {
  PRODUCTPAGEUSP: ProductPageUSP,
  PRODUCTPAGEUSPITEM: ProductPageUSPItem
};
